// extracted by mini-css-extract-plugin
export var container = "_ht-0";
export var content = "_ht-3";
export var customerTitle = "_ht-4";
export var empty = "_ht-5";
export var gray = "_ht-6";
export var header = "_ht-7";
export var info = "_ht-8";
export var loading = "_ht-2";
export var loadingCard = "_ht-9";
export var oneLine = "_ht-a";
export var personName = "_ht-e";
export var pillContainer = "_ht-b";
export var selected = "_ht-1";
export var text = "_ht-c";
export var twoLines = "_ht-d";
export var unread = "_ht-f";
export var unreadIndicator = "_ht-g";